import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export const useRequirements = () => {
  const [requirements, setRequirements] = useState({ functional: [], nonFunctional: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRequirements = async () => {
      try {
        setLoading(true);
        
        // Fetch functional requirements
        const functionalRef = collection(db, 'functionalRequirements');
        const functionalQuery = query(functionalRef, orderBy('order', 'asc'));
        const functionalSnapshot = await getDocs(functionalQuery);
        const functionalData = functionalSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Fetch non-functional requirements
        const nonFunctionalRef = collection(db, 'nonFunctionalRequirements');
        const nonFunctionalQuery = query(nonFunctionalRef, orderBy('order', 'asc'));
        const nonFunctionalSnapshot = await getDocs(nonFunctionalQuery);
        const nonFunctionalData = nonFunctionalSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setRequirements({
          functional: functionalData,
          nonFunctional: nonFunctionalData
        });
        setError(null);
      } catch (err) {
        console.error('Error fetching requirements:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRequirements();
  }, []);

  return { requirements, loading, error };
};

